const checkPasswordHasNumber = (password) => {
    return (/^(?=.*[0-9]).+$/).test(password);
};

const checkPasswordHasLetter = (password) => {
    return (/^(?=.*[a-zA-Z]).+$/).test(password);
};

const getDefaultCountryCode = (locale) => {
    const countryCode = (locale).split('_')[1];
    return countryCode ? countryCode.toLowerCase() : 'us';
};

export {
    checkPasswordHasNumber,
    checkPasswordHasLetter,
    getDefaultCountryCode
};
